import Component from '@glimmer/component';
import AditoolsMenuContext from './aditools-menu-context.ts';
import AditoolsMenuLinks from './aditools-menu-links.ts';
import AditoolsMenuTabs from './aditools-menu-tabs.ts';

interface AditoolsMenubarSignature {
  Element: HTMLMenuElement;
  Blocks: {
    default: [
      {
        'menu-context': typeof AditoolsMenuContext;
        'menu-links': typeof AditoolsMenuLinks;
        'menu-tabs': typeof AditoolsMenuTabs;
      },
    ];
  };
}

export default class AditoolsMenubar extends Component<AditoolsMenubarSignature> {
  menuContextClass = AditoolsMenuContext;
  menuLinksClass = AditoolsMenuLinks;
  menuTabsClass = AditoolsMenuTabs;
}
